import { ModuleWithProviders, NgModule } from '@angular/core';
import { LayoutService } from './services/layout.service';
import { SubjectLinkService } from './services/subject-link.service';
import { SubjectSettingService } from './services/subject-setting.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [],
})
export class SubjectSettingsModule {
  static forRoot(): ModuleWithProviders<SubjectSettingsModule> {
    return {
      ngModule: SubjectSettingsModule,
      providers: [
        LayoutService,
        SubjectLinkService,
        SubjectSettingService,
      ],
    };
  }
}
